<template>
  <div class="song-list">
    <SingerSwitchTab :homepage-img-list="homepageImgList" :tab-img-list="tabImgList" :active="active" @change-active="handleChangeTab" />
    <template v-if="data[active]">
      <SubscribeBar :now="now" :star="data[active]" @subscribe="() => $emit('subscribe', active)" />
      <div class="song-item-wrapper">
        <div class="song-item" v-for="(item, index) in data[active].duets" :key="'duet' + index">
          <ChorusTypeSong :data="item" :active="active" :homepage-img="data[active].img" />
        </div>
        <div class="song-item" v-for="(item, index) in data[active].songs" :key="'song' + index">
          <CoverTypeSong :data="item" :active="active" :homepage-img="data[active].img" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ChorusTypeSong from "./ChorusTypeSong.vue";
import CoverTypeSong from "./CoverTypeSong.vue";
import SingerSwitchTab from "./SingerSwitchTab.vue";

export default {
  name: "SongList",
  components: {
    ChorusTypeSong,
    CoverTypeSong,
    SingerSwitchTab,
  },
  props: {
    now: {
      type: String,
      required: true,
      default: "",
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    active: {
      type: Number,
      default() {
        return 0;
      },
    },
    homepageImgList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tabImgList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    handleChangeTab(j) {
      this.$store.commit("toggleTab", j);
    },
  },
};
</script>

<style lang="scss" scoped>
.song-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
